import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";
import { PersistGate } from "redux-persist/integration/react";
import smoothscroll from "smoothscroll-polyfill";
import "react-toastify/dist/ReactToastify.css";

// import { SocketProvider } from "@contexts/socket/socketProvider";
// import store from "@redux/store";

import { SocketProvider } from "@contexts/socket/socketProvider";
import { store, persistor } from "@redux/store";

import reportWebVitals from "./reportWebVitals";
import Routes from "./routes";

import "./i18n";
import "./index.css";

smoothscroll.polyfill();

console.log("develop versions : 14.0.0 :>> ");
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <SocketProvider>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={true}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          pauseOnHover
          theme="light"
          draggable={false}
        />
        <Routes />
      </SocketProvider>
    </PersistGate>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
